export enum EVENT_CATEGORY {
  SEARCH_MODULE = 'Search Module',
  SEARCH_PAGE_RECENTLY_VIEWED = 'Search Page - Recently Viewed',
  SEARCH_RESULTS_TABLE = 'Search Page - Search Results Table',
  SEARCH_PAGE_CONTENT_TABS = 'Search Page - Content Tabs',
  SEARCH_PAGE_PROFILE_PROTECTIONS = 'Search Page - Profile Protections',
  RELEASE_PAGE = 'Release Page',
  RELEASE_ENTITY_HEADER = 'Release Entity Header',
  ENTITY_LINKS_MODAL = 'Entity Links Modal',
  TRACKS_LINKS_ENTITY_MODAL = 'Track Links Entity Modal',
  ARTIST_PAGE = 'Artist Page',
  ARTIST_ENTITY_HEADER = 'Artist Entity Header',
  ARTIST_METADATA_SECTION = 'Artist Metadata Section',
  ARTIST_RELEASES_TABLE = 'Artist Releases Table',
  ARTIST_APPEARS_ON_TABLE = 'Artist Appears On Table',
  CONTENT_RELOCATION_FORM = 'Content Relocation Form',
  RELEASE_OVERVIEW_TABS = 'Release Overview Tabs',
  RELEASE_METADATA_SECTION = 'Release Metadata Section',
  RELEASE_AVAILABILITY_SECTION = 'Release Availability Section',
  RELEASE_TRACKS_SECTION = 'Release Tracks Section',
  RELEASE_PRESAVE_SECTION = 'Release Presave Section',
  RELEASE_TRACKS_TAB = 'Release Tracks Tab',
  RELEASE_MV_FLAGGED_CLEARANCE = 'Release MV Flagged Clearance',
  RELEASE_DELIVERIES_SECTION = 'Release Deliveries Section',
  RELEASE_CONTRIBUTORS_SECTION = 'Release Contributors Section',
  HEADER = 'Header',
  DOWNLOAD_XML_BUTTON = 'Download XML Button',
  VIEW_DELIVERY_XML_BUTTON = 'View Delivery XML Button',
  CATALOG_EXPORTS_DATA_FRESHNESS = 'Catalog Exports Data Freshness Display',
  CATALOG_EXPORTS_FORM = 'Catalog Exports Form',
  CATALOG_EXPORTS_FORM_DATE_PICKER = 'Catalog Exports Date Picker',
  CATALOG_EXPORTS_TABLE = 'Catalog Exports Table',
  UNASSOCIATED_VIDEOS_REPORT = 'Unassociated Videos Export Page',
  TAKE_DOWN_MODAL = 'Take Down Modal',
  TRACK_PAGE = 'Track Page',
  TRACK_ENTITY_HEADER = 'Track Entity Header',
  TRACK_METADATA_SECTION = 'Track Metadata Section',
  TRACK_RELATED_TRACK = 'Track Related Track',
  TRACK_CONTRIBUTORS_SECTION = 'Track Contributors Section',
  TRACK_CREDITS_SECTION = 'Track Credits Section',
  TRACK_AVAILABILITY_SECTION = 'Track Availability Section',
  TRACK_PRESAVE_SECTION = 'Track Presave Section',
  TRACK_OVERVIEW_TABS = 'Track Overview Tabs',
  HELD_RELEASES_TABLE = 'Held Releases Table',
  HELD_RELEASES_MODAL = 'Held Releases Modal',
  COMMAND_PALETTE = 'Command Palette',
  PROFILE_PROTECTIONS_TABLE = 'Profile Protections Table',
  PROFILE_PROTECTIONS_FILTER = 'Profile Protections Filter',
  APPROVAL_BANNER = 'Approval Banner',
}

export enum EVENT_ACTION {
  CLICK = 'Click',
  SELECT_SEARCH_TYPE = 'Select Search Type',
  SELECT_EXPORT_TYPE = 'Select Export Type',
  UPDATE_EXPORT_NAME = 'Update Export Name',
  SELECT_DATE_RANGE_TYPE = 'Select Date Range Type',
  SELECT_FEED_NAME = 'Select Feed Name',
  SELECT_LICENSOR_NAME = 'Select Licensor Name',
  TOGGLE_ROW = 'Toggle Row',
  CHANGE_NAV_PILL = 'Change Navigation Pill',
  HOVER = 'Hover',
  CHANGE_LICENSOR_FILTER = 'Change Licensor Filter',
  CHANGE_FEED_FILTER = 'Change Feed Filter',
  OPEN = 'Open',
  FILTER = 'Filter',
}

export type GAEvent = {
  eventCategory: EVENT_CATEGORY;
  eventAction: EVENT_ACTION;
  eventLabel?: string;
  eventValue?: number;
};
